<!-- Dialog for adding an elevation table record -->
<mat-dialog-content class="mat-typography" style="color:#003865">

    <h1>Add New Elevation</h1>
    
    <!-- Study Name -->
    <!-- Pre-populated field -->
    <div>
        <mat-form-field style="width:75%;color:darkgrey;font-style:italic;">
            <mat-label>Study Name</mat-label>
            <input matInput [(ngModel)]="selectedStudyName" readonly tabindex="-1">
        </mat-form-field>
    </div>

    <div>
        <!-- Lake Basin ID -->
        <!-- Required field -->
        <mat-form-field appearance="fill" style="width:30%;margin-right:10%">
            <mat-label>Lake Basin ID (must be 8 characters)</mat-label>
            <input matInput [(ngModel)]="lakeBasinID" (ngModelChange)="queryLakeName(lakeBasinID);verifyFormSubmission();" required>
        </mat-form-field>

        <!-- Lake Basin Name -->
        <!-- Pre-populated field -->
        <mat-form-field *ngIf="lakeBasinName" style="width:30%;color:darkgrey;font-style:italic;">
            <mat-label>Lake Basin Name</mat-label>
            <input matInput [(ngModel)]="lakeBasinName" readonly tabindex="-1">
        </mat-form-field>

        <!-- Lake basin ID error, if length is not 8 characters -->
        <p *ngIf="lakeBasinID?.length >= 1 && lakeBasinID?.length !== 8" style='color:red'>Your lake basin ID is {{lakeBasinID.length}} characters, please modify to be 8 characters.</p>
        <!-- Lake Basin ID does not exist -->
        <p *ngIf="lakeBasinValid === false" style="color:red;">{{lakeBasinID}} is not a valid Lake Basin ID, please modify to a valid ID.</p>

    </div>


    <h2>10 Year Elevation</h2>

    <!-- 10 year elevation -->
    <!-- Note: At least one elevation MUST be entered to submit this form -->
    <div>
        <mat-form-field appearance="fill" style="width:75%;">
            <mat-label>10 Year Elevation</mat-label>
            <input type="number" matInput [(ngModel)]="tenYearElevation" (ngModelChange)="verifyElevation();verifyFormSubmission()">
        </mat-form-field>
    </div>

    <!-- 10 year elevation comments -->
    <div>
        <mat-form-field appearance="fill" style="width:75%;">
            <mat-label>10 Year Comments (max 255 characters)</mat-label>
            <textarea matInput [(ngModel)]="tenYearElevationComments"></textarea>
        </mat-form-field>
        <!-- Comments error, if length exceeds 255 characters -->
        <p *ngIf="tenYearElevationComments?.length > 255" style='color:red'>Your 10 year comments have {{tenYearElevationComments.length}} characters, please modify to be no more than 255 characters.</p>
    </div>

    <h2>25 Year Elevation</h2>

    <!-- 25 year elevation -->
    <!-- Note: At least one elevation MUST be entered to submit this form -->
    <div>
        <mat-form-field appearance="fill" style="width:75%;">
            <mat-label>25 Year Elevation</mat-label>
            <input type="number" matInput [(ngModel)]="twentyFiveYearElevation" (ngModelChange)="verifyElevation();verifyFormSubmission()">
        </mat-form-field>
    </div>

    <!-- 25 year elevation comments -->
    <div>
        <mat-form-field appearance="fill" style="width:75%;">
            <mat-label>25 Year Comments (max 255 characters)</mat-label>
            <textarea matInput [(ngModel)]="twentyFiveYearElevationComments"></textarea>
        </mat-form-field>
        <!-- Comments error, if length exceeds 255 characters -->
        <p *ngIf="twentyFiveYearElevationComments?.length > 255" style='color:red'>Your 25 year comments have {{twentyFiveYearElevationComments.length}} characters, please modify to be no more than 255 characters.</p>
    </div>

    <h2>50 Year Elevation</h2>

    <!-- 50 year elevation -->
    <!-- Note: At least one elevation MUST be entered to submit this form -->
    <div>
        <mat-form-field appearance="fill" style="width:75%;">
            <mat-label>50 Year Elevation</mat-label>
            <input type="number" matInput [(ngModel)]="fiftyYearElevation" (ngModelChange)="verifyElevation();verifyFormSubmission()">
        </mat-form-field>
    </div>

    <!-- 50 year elevation comments -->
    <div>
        <mat-form-field appearance="fill" style="width:75%;">
            <mat-label>50 Year Comments (max 255 characters)</mat-label>
            <textarea matInput [(ngModel)]="fiftyYearElevationComments"></textarea>
        </mat-form-field>
        <!-- Comments error, if length exceeds 255 characters -->
        <p *ngIf="fiftyYearElevationComments?.length > 255" style='color:red'>Your 50 year comments have {{fiftyYearElevationComments.length}} characters, please modify to be no more than 255 characters.</p>
    </div>

    <h2>100 Year Elevation</h2>

    <!-- 100 year elevation -->
    <!-- Note: At least one elevation MUST be entered to submit this form -->
    <div>
        <mat-form-field appearance="fill" style="width:75%;">
            <mat-label>100 Year Elevation</mat-label>
            <input type="number" matInput [(ngModel)]="oneHundredYearElevation" (ngModelChange)="verifyElevation();verifyFormSubmission()">
        </mat-form-field>
    </div>

    <!-- 100 year elevation comments -->
    <div>
        <mat-form-field appearance="fill" style="width:75%;">
            <mat-label>100 Year Comments (max 255 characters)</mat-label>
            <textarea matInput [(ngModel)]="oneHundredYearElevationComments"></textarea>
        </mat-form-field>
        <!-- Comments error, if length exceeds 255 characters -->
        <p *ngIf="oneHundredYearElevationComments?.length > 255" style='color:red'>Your 100 year comments have {{oneHundredYearElevationComments.length}} characters, please modify to be no more than 255 characters.</p>
    </div>

    <h2>500 Year Elevation</h2>

    <!-- 500 year elevation -->
    <!-- Note: At least one elevation MUST be entered to submit this form -->
    <div>
        <mat-form-field appearance="fill" style="width:75%;">
            <mat-label>500 Year Elevation</mat-label>
            <input type="number" matInput [(ngModel)]="fiveHundredYearElevation" (ngModelChange)="verifyElevation();verifyFormSubmission()">
        </mat-form-field>
    </div>

    <!-- 500 year elevation comments -->
    <div>
        <mat-form-field appearance="fill" style="width:75%;">
            <mat-label>500 Year Comments (max 255 characters)</mat-label>
            <textarea matInput [(ngModel)]="fiveHundredYearElevationComments"></textarea>
        </mat-form-field>
        <!-- Comments error, if length exceeds 255 characters -->
        <p *ngIf="fiveHundredYearElevationComments?.length > 255" style='color:red'>Your 500 year comments have {{fiveHundredYearElevationComments.length}} characters, please modify to be no more than 255 characters.</p>
    </div>
</mat-dialog-content>

<!-- Error message for the user if the submission button is disabled -->
<!-- Required: [1] Valid Lake Basin ID, [2] at least one elevation value, [3] limited values of 255 characters -->
<mat-dialog-actions align="center">
    <p style="color:red;font:400 14px/20px sans-serif" *ngIf="formSubmissionElevations === false ? true : null || lakeBasinValid === false || lakeBasinID?.length !== 8 || tenYearElevationComments?.length > 255 || twentyFiveYearElevationComments?.length > 255 || fiftyYearElevationComments?.length > 255 || oneHundredYearElevationComments?.length > 255 || fiveHundredYearElevationComments?.length > 255">Please enter the required fields, marked with an asterisk (*), enter in at least 1 elevation value, and ensure you meet the character limits.</p>
</mat-dialog-actions>

<!-- Form actions -->
<mat-dialog-actions align="end">
    <!-- Submit new record button -->
    <button mat-raised-button color="primary" [disabled]="formSubmissionElevations === false ? true : null || lakeBasinValid === false || lakeBasinID?.length !== 8 || tenYearElevationComments?.length > 255 || twentyFiveYearElevationComments?.length > 255 || fiftyYearElevationComments?.length > 255 || oneHundredYearElevationComments?.length > 255 || fiveHundredYearElevationComments?.length > 255" (click)="addElevation()" mat-dialog-close>Submit</button>
    <!-- Close button -->
    <button mat-raised-button color="primary" mat-dialog-close>Close</button>
</mat-dialog-actions>
